import { render, staticRenderFns } from "./rel-receita-pr.vue?vue&type=template&id=4c587d76&scoped=true&"
import script from "./rel-receita-pr.vue?vue&type=script&lang=js&"
export * from "./rel-receita-pr.vue?vue&type=script&lang=js&"
import style0 from "./rel-receita-pr.vue?vue&type=style&index=0&id=4c587d76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c587d76",
  null
  
)

export default component.exports